import api from '@/services/api';
import { make } from 'vuex-pathify';

import { saveFileFromBackend } from '@/assets/js/utility';

const state = {};

const mutations = {
  ...make.mutations(state),
};

const actions = {
  async getCeleryTaskStatus(store, { id, v2 = false }) {
    return v2
      ? (await api.get(`v2/background-tasks/${id}/status`)).data.data
      : (await api.get(`/celery/status/${id}`)).data.data;
  },
  async stopCeleryTask(store, id) {
    // There is no routing for stopping tasks in v2 for now
    await api.get(`/celery/cancel/${id}`);
  },
  async getCeleryTaskResult(store, { id, type = 'file', download = true, v2 = false }) {
    if (type === 'file') {
      const r = v2
        ? await api.get(`v2/background-tasks/${id}/download`, { timeout: 0, responseType: 'arraybuffer' })
        : await api.get(`/celery/get/${id}`, { timeout: 0, responseType: 'arraybuffer' });
      if (download) saveFileFromBackend(r.data, r.headers);
      else return { result: r.data };
    } else if (type === 'data') {
      return v2
        ? (await api.get(`v2/background-tasks/${id}/result`)).data.data
        : (await api.get(`/celery/get/${id}`)).data.data;
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
